import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = (theme) => ({
  root: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    alignItems: 'center',
    marginBottom: theme.spacing(10),
  },
});

const Layout = ({
  classes,
}) => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  useEffect(() => {
    if (!resource?.relationship(fr.relationships.goto.name)) {
      return;
    }
    loadPageContentLink(resource.relationship(fr.relationships.goto.name).link('related'));

    // Open the page from the GoTo query params if we have one
    const gotoUrl = new URL(resource.relationship(fr.relationships.goto.name).link('related').url());
    if (gotoUrl.searchParams.has('pageSelfLink')) {
      const pageSelfLink = gotoUrl.searchParams.get('pageSelfLink');
      loadPageContentLink(pageSelfLink);
    }
  }, [resource.resourceType]);

  return (
    <Box
      className={classes.root}
    >
      <LoadingIndicator />
    </Box>
  );
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
